export default __webpack_public_path__ + "static/16-bc4e3089e799f9e9afc70712154a4815.png";